import { render, staticRenderFns } from "./journalAnalysis.vue?vue&type=template&id=28d08267&scoped=true&"
import script from "./journalAnalysis.vue?vue&type=script&lang=js&"
export * from "./journalAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./journalAnalysis.vue?vue&type=style&index=0&id=28d08267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d08267",
  null
  
)

export default component.exports